import api from "@/api/axios";
export default {
  namespaced: true,
  state: {
    categories: [],
  },
  mutations: {
    SET_CATEGORIES(state, payload) {
      state.categories = payload;
    },
  },
  actions: {
    async getCategories({ commit }) {
      try {
        commit("setLoading", true, { root: true });

        const reasons = await api.get("/admin/categories", {
          params: {
            all: 1,
          },
        });
        commit("SET_CATEGORIES", reasons.data.data);

        commit("setLoading", false, { root: true });
      } catch (error) {
        commit("setLoading", false, { root: true });
        return error;
      }
    },
  },
};
